// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"54":"e85246f4","225":"29076d52","413":"e5386e88","560":"f3c03f0a","696":"93e376a5","727":"8e4014a0","810":"3607cb22"}[chunkId] + ".js";
};